import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type PostTeamTagAutocompletePayloadType = {
  query: string;
  limit: number;
};

export const apiFetchTeamTagAutocomplete = async ({
  domain = useTenantStore().domain,
  payload,
  errorConfig = {},
  callbacks = {},
  signal = null,
}: PostRequestArgsType<PostTeamTagAutocompletePayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.teamTagAutocomplete({ domain }),
      payload,
      signal,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
